import Site from './site';

const modules = [
    Site
];

export default modules;